import { FC } from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { Button, createBemBlockBuilder, Hyperlink } from '@ebsco-ui/ebsco-ui';

import { Icon } from '@app/components';
import { Route } from '@app/constants';

import './AccountCreationSuccess.scss';

const cnBem = createBemBlockBuilder(['accountCreatedScreen']);

export const accountRegistrationLink =
  'https://www.loc.gov/rr/readerregistration.html';

export const AccountCreationSuccess: FC = () => {
  const { $t } = useIntl();

  return (
    <div data-auto="account-creation-success" className={cnBem()}>
      <div className={cnBem('__icon')}>
        <Icon icon={faCheckCircle} />
      </div>
      <h2>
        {$t({
          id: 'createAccount.accountCreated',
          defaultMessage: 'Account created',
        })}
      </h2>
      <div className={cnBem('__accountCreatedText')}>
        {$t({
          id: 'createAccount.verifyEmail',
          defaultMessage:
            'Your account has been created. You will need to verify your email address to sign in.',
        })}
      </div>
      <Link to={Route.search} className={cnBem('__navigationLink')}>
        <Button styleType="solid" className={cnBem('__navigationButton')}>
          {$t({
            id: 'createAccount.backToCatalog',
            defaultMessage: 'Back to catalog',
          })}
        </Button>
      </Link>
      <div
        className={cnBem('__registeredReader')}
        data-auto="account-registered-reader"
      >
        {$t({
          id: 'createAccount.registeredReader',
          defaultMessage: 'Would you like to become a Registered Reader?',
        })}
      </div>
      <p>
        {$t(
          {
            id: 'createAccount.readerIdRequired',
            defaultMessage:
              "To use the Library's research areas and request materials you must have a Reader Identification Card. Learn more on the Library’s <link>Reader Registration</link> page.",
          },
          {
            br: <br />,
            link: chunks => (
              <Hyperlink
                data-auto="account-registration"
                href={accountRegistrationLink}
                target="_blank"
                rel="noreferrer"
              >
                {chunks}
              </Hyperlink>
            ),
          }
        )}
      </p>
      <Link to={Route.login}>
        <Button styleType="passive" className={cnBem('__navigationButton')}>
          {$t({
            id: 'createAccount.signInAndPreregister',
            defaultMessage: 'Sign in and preregister',
          })}
        </Button>
      </Link>
    </div>
  );
};
